import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export interface UpdateJobGroupProps {
  recurringJobGroupId: string;
  nome: string;
  ativo: boolean;
}

export default function useUpdateJobGroup() {
  return useMutation(
    URL.RECURRING_JOB_GROUP.ATUALIZAR("id"),
    async (body: UpdateJobGroupProps) => {
      const response = await http.put(
        URL.RECURRING_JOB_GROUP.ATUALIZAR(body.recurringJobGroupId),
        body,
      );
      return response;
    },
  );
}
